import {formatBirthdate} from '@/shared/utils/formatBirthdate';

const SCHEDULE_BASE = 'https://mylabsdirect.as.me/schedule.php';
const APPOINTMENT_TYPE = '34976104';
// Acuity's custom intake field for date of birth. The key is emitted
// literally (not percent-encoded) to stay byte-identical to the query
// string Acuity has always received -- this endpoint is a third party we
// cannot re-verify against from here, so the known-working key is left
// alone. Only the value is encoded.
const DOB_FIELD = 'field:10422557';

// A correctly formatted birthdate is always MM/DD/YYYY. formatBirthdate can
// fall through to returning its raw, unparseable input for a malformed
// string (anything that isn't US-style or ISO and that also fails the
// `Date` constructor's fallback parse); that raw garbage must never reach
// Acuity, so anything that doesn't match this shape is treated as absent.
const FORMATTED_BIRTHDATE = /^\d{2}\/\d{2}\/\d{4}$/;

export interface AcuityPrefill {
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    birthday?: string | Date | null;
}

/**
 * Build the prefilled Acuity kit-pickup scheduling URL.
 *
 * The DOB goes through the shared UTC-safe formatter: this value leaves our
 * system for a third party, so a local-timezone shift here books the patient
 * under the wrong birthdate rather than merely displaying one.
 */
export function buildAcuityScheduleUrl(user: AcuityPrefill): string {
    const params = new URLSearchParams({
        appointmentType: APPOINTMENT_TYPE,
        firstName: user.firstName ?? '',
        lastName: user.lastName ?? '',
        phone: user.phone ?? '',
        email: user.email ?? '',
    });
    const dob = formatDobForAcuity(user.birthday);
    return `${SCHEDULE_BASE}?${params.toString()}&${DOB_FIELD}=${encodeURIComponent(dob)}`;
}

function formatDobForAcuity(birthday: AcuityPrefill['birthday']): string {
    if (!birthday) return '';
    const formatted = formatBirthdate(birthday);
    return FORMATTED_BIRTHDATE.test(formatted) ? formatted : '';
}
